import React from "react";
import { bool, string } from "prop-types";
/* eslint-disable object-shorthand */
import { createDfpAdComponent, WithLazy } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

const ViewPortSizeMappingHorizontal728to320 = [
  { viewport: [980, 90], sizes: [[728, 90]] },
  { viewport: [320, 0], sizes: [[320, 50]] },
  { viewport: [0, 0], sizes: [[320, 50]] }
];

const ViewPortSizeMappingVertical600to250 = [
  { viewport: [980, 90], sizes: [[300, 600]] },
  { viewport: [320, 0], sizes: [[300, 250]] },
  { viewport: [0, 0], sizes: [[300, 250]] }
];

// const viewPortSizeMapping728to160 = [
//   { viewport: [160, 0], sizes: [[160, 600]] },
//   { viewport: [300, 0], sizes: [[300, 50]] },
//   { viewport: [300, 0], sizes: [[300, 250]] },
//   { viewport: [300, 0], sizes: [[300, 600]] },
//   { viewport: [320, 0], sizes: [[320, 50]] },
//   { viewport: [320, 0], sizes: [[320, 100]] },
//   { viewport: [336, 0], sizes: [[336, 280]] },
//   { viewport: [728, 0], sizes: [[728, 90]] }
// ];

const viewPortSizeMapping728to300StoryBody = [
  { viewport: [980, 90], sizes: [[728, 90]] },
  { viewport: [300, 0], sizes: [[300, 250]] },
  { viewport: [320, 0], sizes: [[320, 100]] },
  { viewport: [336, 0], sizes: [[336, 280]] },
  { viewport: [0, 0], sizes: [[300, 100]] }
];

const ViewPortSizeMappingHorizontal728to300 = [
  { viewport: [980, 90], sizes: [[728, 90]] },
  { viewport: [300, 0], sizes: [[300, 250]] },
  { viewport: [0, 0], sizes: [[300, 250]] }
];

const CONFIG = {
  NH_HP_728x90: {
    adUnit: "NH_HP_728x90",
    sizes: [[728, 90], [320, 50]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontal728to320
  },

  /* Newly Added */
  NH_Body: {
    adUnit: "NH_Body",
    sizes: [[728, 90], [300, 250]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontal728to300
  },

  NH_E_Body: {
    adUnit: "NH_E_Body",
    sizes: [[728, 90], [300, 250]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontal728to300
  },

  NH_Footer_Sticky: {
    adUnit: "NH_Footer_Sticky",
    sizes: [[728, 90], [320, 50]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontal728to320
  },

  NH_Article_LHS_Sticky: { adUnit: "NH_Article_LHS_Sticky", sizes: [[160, 600]] }, // To target this only on desktop
  /* End */

  // "ATD_Nationalheraldindia.com": {
  //   adUnit: "ATD_Nationalheraldindia.com",
  //   sizes: [[728, 90], [300, 250]],
  //   viewPortSizeMapping: viewPortSizeMapping728to160
  // },
  // "ATD_navjivanindia.com_ST": {
  //   adUnit: "ATD_navjivanindia.com_ST",
  //   sizes: [[728, 90], [300, 250]],
  //   viewPortSizeMapping: viewPortSizeMapping728to160
  // },
  // ATD_Qaumiawaz_ST: {
  //   adUnit: "ATD_Qaumiawaz_ST",
  //   sizes: [[728, 90], [300, 250]],
  //   viewPortSizeMapping: viewPortSizeMapping728to160
  // },

  NH_300x600: {
    adUnit: "NH_300x600",
    sizes: [[300, 600], [300, 250]],
    viewPortSizeMapping: ViewPortSizeMappingVertical600to250
  },
  NH_300x250: { adUnit: "NH_300x250", sizes: [[300, 250]] },
  NH_MP_300x600: { adUnit: "NH_300x600", sizes: [[300, 600]] },

  Election_NH_HP_728x90: {
    adUnit: "Election_NH_HP_728x90",
    sizes: [[728, 90], [320, 50]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontal728to320
  },

  Election_NH_HP_320X50: {
    adUnit: "Election_NH_HP_320X50",
    sizes: [[320, 50]]
  },

  Election_NH_HP_300X250: {
    adUnit: "Election_NH_HP_300X250",
    sizes: [[300, 250]]
  }
};

const DfpAdContent = createDfpAdComponent({
  defaultNetworkID: "21687414328",
  config: CONFIG,
  targeting: function(state) {
    const params = {
      publisher: get(state, ["qt", "config", "publisher-attributes", "dfp_target_value"]),
      pageType: get(state, ["qt", "pageType"]),
      env: get(state, ["qt", "config", "publisher-attributes", "env"])
    };
    if (
      get(state, ["qt", "pageType"]) === "story-page" &&
      get(state, ["qt", "data", "story", "metadata", "sponsored-by"])
    ) {
      params.sponsor = get(state, ["qt", "data", "story", "metadata", "sponsored-by"]);
      return params.sponsor;
    }
    return params;
  },
  disableInitialLoad: true,
  singleRequest: true
});

const DfpAdView = function(props) {
  if (props.isActivePlan) return null;

  return (
    // <div>
    //   <DfpAdContent {...props} />
    // </div>
    <WithLazy margin="300px">
      {() => (
        <div id="ad-holder" data-size={`${props.width}x${props.height}`}>
          <DfpAdContent {...props} />
        </div>
      )}
    </WithLazy>
  );
};

DfpAdView.propTypes = {
  isActivePlan: bool,
  height: string,
  width: string
};

function mapStateToProps(state) {
  return {
    isActivePlan: get(state, ["userReducer", "isActivePlan"], false)
  };
}

export const DfpAd = connect(
  mapStateToProps,
  null
)(DfpAdView);
